// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__sSKFc","rotator":"Spinner_rotator__q5OJW","path":"Spinner_path__MLGfM","colors":"Spinner_colors___p7Wj","dash":"Spinner_dash__EZsSj"};